// extracted by mini-css-extract-plugin
export default {"page":"GY","heading":"HY","subheading":"IY","flavorbox":"JY","inner":"KY","image":"LY","label":"MY","flavorselect":"NY","arrow":"OY","flavorswrap":"PY","flavorsheader":"QY","flavorsnav":"RY","flavorsinner":"SY","cancelbtn":"TY","flavorsbottom":"UY","retakebtn":"VY","continueBtn":"WY","drawerinner":"XY","videowrap":"YY","flavorsbottomnav":"ZY"};
    if(module.hot) {
      // 1738064243411
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  